import { render } from "./Select.vue?vue&type=template&id=27349f7e&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=27349f7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27349f7e"

export default script